import { Flex } from '@chakra-ui/react';
import { Resizable } from '@halo/ui-chat-react';
import { Outlet } from 'react-router';
import { useLastHandle } from '@/scripts/router';
import { PANELS_CONFIG, useAppResponsive } from '../helpers';

export default function MessagePage() {
  const sidebar = useLastHandle()?.msgSidebar as React.ReactNode;
  const { sidebarWidth } = useAppResponsive();

  return (
    <Flex className="Messages" h="full">
      <Resizable.Root
        defaultWidths={sidebarWidth}
        minWidths={[PANELS_CONFIG.PANELS_SIDEBAR_MIN_WIDTH]}
        maxWidths={[PANELS_CONFIG.PANELS_SIDEBAR_MAX_WIDTH]}
      >
        <Resizable.Panel index={0}>{sidebar}</Resizable.Panel>
        <Resizable.Handle index={0} />
        <Resizable.Panel minW={476} index={1}>
          <Outlet />
        </Resizable.Panel>
      </Resizable.Root>
    </Flex>
  );
}
